// extracted by mini-css-extract-plugin
export default {"formWrapper":"styles_formWrapper__SfpNw","content":"styles_content__sUPLy"};